// 座椅子: 脚なしの床置きチェア
import { Box } from '@react-three/drei'

export default function FloorChairMesh({ width, height, depth, position, color, isSelected }) {
    // 座面: 固定の薄さ（10%）- 高さ調整時は変わらない
    const seatThickness = height * 0.10
    const seatY = position[1] - height / 2 + seatThickness / 2  // 底面がワイヤーフレームに接触
    // 背もたれ: 残りの高さ（90%）- 高さ調整時はここだけが変動
    const backHeight = height - seatThickness
    const backY = position[1] - height / 2 + seatThickness + backHeight / 2  // 座面の上から上端まで

    return (
        <group>
            {/* 座面クッション（幅とZ位置を調整してワイヤーフレームに接触） */}
            <Box args={[width, seatThickness, depth]} position={[0, seatY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 背もたれ（後端がワイヤーフレームに接触） */}
            <Box args={[width, backHeight, depth * 0.15]} position={[0, backY, -depth * 0.425]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 座面クッション */}
            <Box args={[width, seatThickness, depth]} position={[0, seatY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 背もたれ */}
            <Box args={[width, backHeight, depth * 0.15]} position={[0, backY, -depth * 0.425]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
